import ComparisonItem from '@/types/comparison-item';
import { HOLDING_TYPES } from './portfolios';
import { COMPARISON_ITEM_TYPES } from './constants';

/**
 * Filters valid comparison items tax analysis
 * @param {ComparisonItem[]} items the items to filter
 */
export const filterTaxAnalysisItems = (items: ComparisonItem[]) => items.filter(item => item.type !== COMPARISON_ITEM_TYPES.PORTFOLIO);
